module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.clubList) ? _c('div', _vm._l((_vm.clubList), function(club) {
    return _c('div', {
      staticClass: "panel league row columns",
      class: {
        inactive: _vm.activatedLeague !== null && _vm.activatedLeague !== undefined && _vm.activatedLeague !== _vm.getLatestLeagueId(club)
      },
      attrs: {
        "id": club.id
      },
      on: {
        "click": function($event) {
          return _vm.triggerLeague(club)
        }
      }
    }, [_c('div', {
      staticClass: "row columns"
    }, [_c('img', {
      staticClass: "small-team-icon",
      attrs: {
        "src": 'https://back.bloodbowlclub.com' + club.icon_path,
        "alt": "team"
      }
    })])])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14f12ba2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/league-panel.vue
// module id = 712
// module chunks = 0